import { combineReducers } from 'redux';
import * as serviceRequests from './ServiceRequest';
import * as announcement from './Announcement';
import * as unit from './Unit';
import * as booking from './Booking';
import * as visitorParking from './VisitorParking';
import * as violation from './Violations';
import * as user from './User';
import * as todo from './ToDo';
import * as event from './Event';

export const Types = {
    ...serviceRequests.Types,
    ...announcement.Types,
    ...unit.Types,
    ...booking.Types,
    ...visitorParking.Types,
    ...violation.Types,
    ...user.Types,
    ...todo.Types,
    ...event.Types
};

export const Actions = {
    ...serviceRequests.Actions,
    ...announcement.Actions,
    ...unit.Actions,
    ...booking.Actions,
    ...visitorParking.Actions,
    ...violation.Actions,
    ...user.Actions,
    ...todo.Actions,
    ...event.Actions
};

const rootReducer = combineReducers({
  createServiceRequest: serviceRequests.addServiceRequestReducer,
  serviceRequestUpdates: serviceRequests.serviceRequestUpdatesReducer,
  announcement: announcement.announcementRequestReducer,
  booking: booking.bookingRequestReducer,
  visitorParking: visitorParking.visitorParkingRequestReducer,
  violation: violation.violationRequestReducer,
  event: event.eventRequestReducer,
  fetchServiceRequest: serviceRequests.fetchServiceRequestReducer,
  fetchServiceRequestUpdates: serviceRequests.fetchServiceRequestUpdatesReducer,
  fetchAnnouncement: announcement.fetchAnnouncementRequestReducer,
  fetchUnit: unit.fetchUnitRequestReducer,
  fetchBooking: booking.fetchBookingRequestReducer,
  fetchAmenitiesList: booking.fetchAmenitiesListReducer,
  fetchVisitorParking: visitorParking.fetchVisitorParkingRequestReducer,
  fetchViolation: violation.fetchViolationRequestReducer,
  fetchUser: user.fetchUserRequestReducer,
  fetchToDo: todo.fetchToDoRequestReducer,
  fetchEvent: event.fetchEventRequestReducer,
  task: todo.toDoRequestReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
